import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconEffects: React.FC<IconProps> = ({ width = 18, height = 18 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
        >
            <g clip-path="url(#clip0_5923_22652)">
                <path
                    d="M8.79375 2.73472C9.04225 2.73472 9.24375 2.53322 9.24375 2.28472V1.58672C9.24375 1.33822 9.04225 1.13672 8.79375 1.13672C8.54525 1.13672 8.34375 1.33822 8.34375 1.58672V2.28472C8.34375 2.53322 8.54525 2.73472 8.79375 2.73472Z"
                    fill="#303030"
                />
                <path
                    d="M8.79375 14.4375C8.54525 14.4375 8.34375 14.639 8.34375 14.8875V15.5855C8.34375 15.834 8.54525 16.0355 8.79375 16.0355C9.04225 16.0355 9.24375 15.834 9.24375 15.5855V14.8875C9.24375 14.639 9.04225 14.4375 8.79375 14.4375Z"
                    fill="#303030"
                />
                <path
                    d="M15.7935 8.13672H15.0955C14.847 8.13672 14.6455 8.33822 14.6455 8.58672C14.6455 8.83522 14.847 9.03672 15.0955 9.03672H15.7935C16.042 9.03672 16.2435 8.83522 16.2435 8.58672C16.2435 8.33822 16.042 8.13672 15.7935 8.13672Z"
                    fill="#303030"
                />
                <path
                    d="M2.49175 8.13672H1.79375C1.54525 8.13672 1.34375 8.33822 1.34375 8.58672C1.34375 8.83522 1.54525 9.03672 1.79375 9.03672H2.49175C2.74025 9.03672 2.94175 8.83522 2.94175 8.58672C2.94175 8.33822 2.74025 8.13672 2.49175 8.13672Z"
                    fill="#303030"
                />
                <path
                    d="M5.05738 5.48588C5.14538 5.57388 5.26038 5.61788 5.37538 5.61788C5.49038 5.61788 5.60588 5.57388 5.69388 5.48588C5.86988 5.31038 5.86988 5.02538 5.69388 4.84987L4.77288 3.92887C4.59688 3.75288 4.31238 3.75288 4.13688 3.92887C3.96088 4.10438 3.96088 4.38938 4.13688 4.56488L5.05738 5.48588Z"
                    fill="#303030"
                />
                <path
                    d="M12.53 11.6867C12.354 11.5107 12.0695 11.5107 11.894 11.6867C11.7185 11.8627 11.718 12.1477 11.894 12.3232L12.815 13.2442C12.903 13.3322 13.018 13.3762 13.133 13.3762C13.248 13.3762 13.363 13.3322 13.451 13.2442C13.627 13.0682 13.627 12.7832 13.451 12.6077L12.53 11.6867Z"
                    fill="#303030"
                />
                <path
                    d="M12.8147 3.92894L11.8937 4.84944C11.7177 5.02494 11.7177 5.30994 11.8937 5.48544C11.9817 5.57344 12.0967 5.61744 12.2117 5.61744C12.3267 5.61744 12.4417 5.57344 12.5297 5.48544L13.4507 4.56444C13.6267 4.38894 13.6267 4.10394 13.4507 3.92844C13.2752 3.75294 12.9907 3.75294 12.8147 3.92894Z"
                    fill="#303030"
                />
                <path
                    d="M5.05739 11.6861L4.13639 12.6071C3.96039 12.7831 3.96039 13.0681 4.13639 13.2436C4.22439 13.3316 4.33939 13.3756 4.45439 13.3756C4.56939 13.3756 4.68439 13.3316 4.77239 13.2436L5.69389 12.3231C5.86989 12.1471 5.86989 11.8621 5.69389 11.6866C5.51789 11.5111 5.23339 11.5106 5.05739 11.6861Z"
                    fill="#303030"
                />
                <path
                    d="M13.0157 8.79463L11.5757 9.65613C10.8717 10.0776 10.2827 10.6666 9.8612 11.3706L8.9997 12.8106C8.9067 12.9661 8.6807 12.9661 8.5877 12.8106L7.7262 11.3706C7.3047 10.6666 6.7157 10.0776 6.0117 9.65613L4.5717 8.79463C4.4162 8.70163 4.4162 8.47563 4.5717 8.38263L6.0117 7.52112C6.7157 7.09962 7.3047 6.51062 7.7262 5.80662L8.5877 4.36662C8.6807 4.21113 8.9067 4.21113 8.9997 4.36662L9.8612 5.80662C10.2827 6.51062 10.8717 7.09962 11.5757 7.52112L13.0157 8.38263C13.1717 8.47563 13.1717 8.70163 13.0157 8.79463Z"
                    fill="#303030"
                />
            </g>
            <defs>
                <clipPath id="clip0_5923_22652">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.793945 0.585938)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEffects;
